export const messages = {
  en: {
    getInoutInfo: {
      queryTitle: 'Query Conditions',
      listTitle: 'Purchase Details',
      startTime: 'Start Time',
      endTime: 'End Time',
      productName: 'Product Name',
      barCode: 'Barcode',
      prodName: 'Product Name',
      specName: 'Specification',
      prodCount: 'Inventory',
      actCount: 'Inbound',
      price: 'Unit Price',
      unitName: 'Unit',
      amount: 'Inbound Amount',
      tActCount: 'Return Quantity',
      tAmount: 'Return Amount',
      createTime: 'Purchase Time'
    }
  },
  zh: {
    getInoutInfo: {
      queryTitle: '查询条件',
      listTitle: '进货明细',
      startTime: '开始时间',
      endTime: '结束时间',
      productName: '商品名称',
      barCode: '条形码',
      prodName: '商品名称',
      specName: '规格名称',
      prodCount: '库存',
      actCount: '入库',
      price: '单价',
      unitName: '单位',
      amount: '入库金额',
      tActCount: '退货数量',
      tAmount: '退货金额',
      createTime: '进货时间'
    }
  }
}